import Axios from '@/utils/request'
export const baseUrl = Axios.defaults.baseURL

export const showUrl = process.env.VUE_APP_IMG_URL
export const uploadUrl = baseUrl + '/file/file/upload' // 图片上传地址
export const markdownUpload = '/file/file/upload' // 图片上传地址

// 获取公司信息  -- 不需要登录
export const getSiteInfo = (data) => {
    return Axios.request({
        method: 'get',
        url: '/spypbottom/spypBottom/list',
        params: data
    })
}

export const getLeftmenuList = (data) => {
    return Axios.request({
        method: 'get',
        url: '/ljtz/ljlb/getList',
        params: data
    })
}

// ---获取验证码--- -- 不需要登录
export const getValiCode = (data) => {
    return Axios.request({
        method: "get",
        url: '/sys/getCode',
        params: data
    })
}

// ---登录--- -- 不需要登录
export const login = (data) => {
    return Axios.request({
        method: "post",
        url: "/sys/login",
        data: data
    })
}

// ---注册--- -- 不需要登录
export const register = (data) => {
    return Axios.request({
        method: "post",
        url: "/sys/user/save",
        data: data
    })
}

// ---修改用户信息--- -- 不需要登录
export const saveUserInfo = (data) => {
    return Axios.request({
        method: "post",
        url: "/sys/user/saveInfo",
        data: data
    })
}

// ---修改用户密码--- -- 不需要登录
export const updateUserPassword = (data) => {
    return Axios.request({
        method: "post",
        url: "/sys/user/savePwd",
        data: data
    })
}

//通过token获取用户信息 -- 需要登录
export const getUserInfo = (data) => {
    return Axios.request({
        method: "get",
        url: "/app/sys/user/info",
        params: data
    })
}

//通过id获取用户信息 -- 需要登录
export const getFullUserInfo = (data) => {
    return Axios.request({
        method: "get",
        url: "/sysuser/sysUser/queryById",
        params: data
    })
}

//获取顶部导航 -- 不需要登录
export const getOneColumn = (data) => {
    return Axios.request({
        method: "get",
        url: "/columns/columns/oneColumn",
        params: data
    })
}

//获取左侧导航 -- 不需要登录
export const getSubColumn = (data) => {
    return Axios.request({
        method: "get",
        url: "/columns/columns/subColumn",
        params: data
    })
}

//获取党史教育 -- 不需要登录
export const getPartyHistory = (data) => {
    return Axios.request({
        method: 'get',
        url: '/navigationmap/navigationmap/queryById',
        params: data
    })
}

//获取左侧导航单个录入内容 -- 不需要登录 //获取左侧导航单根分类录入内容
export const getPublishedContent = (data) => {

    return Axios.request({
        method: 'get',
        url: '/releases/releases/getReleasesByColumnId', //'/releases/releases/queryPublishedContent'
        params: { columnId: data.id, ...data }

    })

}

//获取左侧导航单个录入内容 -- 不需要登录 //获取左侧导航单根分类录入内容
export const getSingleContent = (data) => {
    return Axios.request({
        method: 'get',
        url: '/releases/releases/queryPublishedContent',
        params: data
    })
}

//获取中心新闻录入内容 -- 不需要登录
export const getNewsCenterList = (data) => {
    return Axios.request({
        method: 'get',
        url: '/newscenter/newsCenter/list',
        params: data
    })
}

//获取中心新闻录入内容 -- 不需要登录
export const getSlideshowList = (data) => {
    return Axios.request({
        method: 'get',
        url: '/slideshow/slideshow/listAll',
        params: data
    })
}
export const getSlideshowList1 = (data) => {
    return Axios.request({
        method: 'get',
        url: '/slideshow/slideshow/list',
        params: data
    })
}
//获取左侧导航单根分类录入内容 -- 不需要登录
export const getReleasesByColumnId = (data) => {
    return Axios.request({
        method: 'get',
        url: '/releases/releases/getReleasesByColumnId',
        params: data
    })
}

//获取单个新闻 -- 不需要登录
export const getReleaseById = (data) => {
    // console.log(data)
    return Axios.request({
        method: 'get',
        url: '/releases/releases/queryById',
        params: data
    })

}

//获取单个中心新闻 -- 不需要登录
export const getNewsCenterById = (data) => {
    return Axios.request({
        method: 'get',
        url: '/newscenter/newsCenter/queryById',
        params: data
    })
}

//获取单个图片新闻 -- 不需要登录
export const getSlideshowById = (data) => {
    return Axios.request({
        method: 'get',
        url: '/slideshow/slideshow/queryById',
        params: data
    })
}

//查询标题关键字获取单个新闻 -- 不需要登录
export const getReleaseByKeywords = (data) => {
    return Axios.request({
        method: 'get',
        url: '/releases/releases/list',
        params: data
    })
}

//获取友情链接 -- 不需要登录
export const getFriendsTreeData = (data) => {
    return Axios.request({
        method: 'get',
        url: '/linkfriendly/linkFriendly/treeData',
        params: data
    })
}

//留言 -- 需要登录
export const editMessage = (data) => {
    return Axios.request({
        method: 'post',
        url: '/messageboard/messageBoard/save', //'/messageboard/messageBoard/submitInfo',
        data: data
    })
}

//获取留言 -- 不需要登录
export const getMessages = (data) => {
    return Axios.request({
        method: 'get',
        url: '/messageboard/messageBoard/list',
        params: data
    })
}

//通过id获取单个留言 -- 不需要登录
export const getMessageById = (data) => {
    return Axios.request({
        method: 'get',
        url: '/messageboard/messageBoard/queryById',
        params: data
    })
}

//获取部门列表 --不需要登录
export const getDepartments = (data) => {
    return Axios.request({
        method: 'get',
        // url: '/departments/departments/list',
        url: '/sys/office/treeData',
        params: data
    })
}

//编辑立卷申请表 --需要登录
export const saveArchiveFilling = (data) => {
    return Axios.request({
        method: 'post',
        url: '/filingapplication/filingapplication/userSave',
        data: data
    })
}

//获取立卷申请表列表 --需要登录
export const getArchives = (data) => {
    return Axios.request({
        method: 'get',
        url: '/filingapplication/filingapplication/list',
        params: data
    })
}

//获取公示立卷申请表列表 --不需要登录
export const getArchivesPublicity = (data) => {
    return Axios.request({
        method: 'get',
        url: '/filingapplication/filingapplication/list2',
        params: data
    })
}






//获取单个立卷申请表 --需要登录
export const getArchive = (data) => {
    return Axios.request({
        method: 'get',
        url: '/filingapplication/filingapplication/queryById',
        params: data
    })
}

//编辑创新申请表 --需要登录
export const saveInnovateFilling = (data) => {
    return Axios.request({
        method: 'post',
        url: '/innovation/innovation/userSave',
        data: data
    })
}

//获取创新申请表列表 --需要登录
export const getInnovates = (data) => {
    return Axios.request({
        method: 'get',
        url: '/innovation/innovation/list',
        params: data
    })
}

//获取公示创新申请表列表 --需要登录
export const getInnovatesPublicity = (data) => {
    return Axios.request({
        method: 'get',
        url: '/innovation/innovation/list2',
        params: data
    })
}

//获取单个创新申请表 --需要登录
export const getInnovate = (data) => {
    return Axios.request({
        method: 'get',
        url: '/innovation/innovation/queryById',
        params: data
    })
}

//获取字典数据 --不需要登录
export const getDictMap = (data) => {
    return Axios.request({
        method: 'get',
        url: '/sys/dict/getDictValue',
        params: data
    })
}

//签收立卷申请--需要登录
export const receiptArchive = (data) => {
    return Axios.request({
        method: "post",
        url: "/filingapplication/filingapplication/receipt",
        data: data
    })
}

//批量受理立卷申请--需要登录
export const doBatchArchiveAcceptance = (data) => {
    return Axios.request({
        method: "post",
        url: "/filingapplication/filingapplication/acceptance",
        data: data
    })
}

//批量发补立卷申请--需要登录
export const doBatchArchiveReissue = (data) => {
    return Axios.request({
        method: "post",
        url: "/filingapplication/filingapplication/sendToRepair",
        data: data
    })
}

//批量收到立卷申请补充资料--需要登录
export const doBatchArchiveReceived = (data) => {
    return Axios.request({
        method: "post",
        url: "/filingapplication/filingapplication/received",
        data: data
    })
}

//批量办结立卷申请--需要登录
export const doBatchArchiveSettlement = (data) => {
    return Axios.request({
        method: "post",
        url: "/filingapplication/filingapplication/transferredTo",
        data: data
    })
}

//立卷申请-查看办理明细-需要登录
export const getArichiveSettlementDetail = (data) => {
    return Axios.request({
        method: "get",
        url: '/levelscontent/levelsContent/list',
        params: data
    })
}

//签收创新申请--需要登录
export const receiptInnovate = (data) => {
    return Axios.request({
        method: "post",
        url: "/innovation/innovation/receipt",
        data: data
    })
}

//批量受理创新申请--需要登录
export const doBatchInnovateAcceptance = (data) => {
    return Axios.request({
        method: "post",
        url: "/innovation/innovation/acceptance",
        data: data
    })
}

//批量发补创新申请--需要登录
export const doBatchInnovateReissue = (data) => {
    return Axios.request({
        method: "post",
        url: "/innovation/innovation/sendToRepair",
        data: data
    })
}

//批量收到创新申请补充资料--需要登录
export const doBatchInnovateReceived = (data) => {
    return Axios.request({
        method: "post",
        url: "/innovation/innovation/received",
        data: data
    })
}

//批量创新--医疗审评科召开界定会--需要登录
export const doBatchInnovateConvening = (data) => {
    return Axios.request({
        method: "post",
        url: "/innovation/innovation/convening",
        data: data
    })
}

//批量办结创新申请--需要登录
export const doBatchInnovateSettlement = (data) => {
    return Axios.request({
        method: "post",
        url: "/innovation/innovation/transferredTo",
        data: data
    })
}

//创新申请-查看办理明细-需要登录
export const getInnovateSettlementDetail = (data) => {
    return Axios.request({
        method: "get",
        url: '/innovationcontent/innovationContent/list',
        params: data
    })
}

//删除文档-需要登录
export const deleteFile = (data) => {
    return Axios.request({
        method: "get",
        url: '/sys/file/webupload/deleteByUrl',
        params: data
    })
}

//沟通预约-不需要登录
export const saveSubscribe = (data) => {
    return Axios.request({
        method: "post",
        url: "/subscribe/subscribe/save",
        data: data
    })
}
